export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10434.d0724cbd.jpg";